import * as types from './constants';

export function getRule({ getRuleApi, query }) {
  return {
    type: types.GET_RULE_REQUEST,
    getRuleApi,
    query,
  };
}

export function getRuleSummarize({ getRuleSummarizeApi, rule }) {
  return {
    type: types.GET_RULE_SUMMARIZE_REQUEST,
    getRuleSummarizeApi,
    rule,
  };
}

export function updateLikeResultRule({ updateLikeResultApiRule, requestId }) {
  return {
    type: types.UPDATE_LIKE_ANSWER_REQUEST_RULE,
    updateLikeResultApiRule,
    requestId,
  };
}

export function updateDislikeResultRule({
  updateDislikeResultApiRule,
  feedback,
  requestId,
}) {
  return {
    type: types.UPDATE_DISLIKE_ANSWER_REQUEST_RULE,
    updateDislikeResultApiRule,
    feedback,
    requestId,
  };
}

export function updateLikeResultSummarize({
  updateLikeResultApiSummarize,
  requestId,
}) {
  return {
    type: types.UPDATE_LIKE_ANSWER_REQUEST_SUMMARIZE,
    updateLikeResultApiSummarize,
    requestId,
  };
}

export function updateDislikeResultSummarize({
  updateDislikeResultApiSummarize,
  feedback,
  requestId,
}) {
  return {
    type: types.UPDATE_DISLIKE_ANSWER_REQUEST_SUMMARIZE,
    updateDislikeResultApiSummarize,
    feedback,
    requestId,
  };
}

export function resetRule() {
  return {
    type: types.RESET_RULE,
  };
}
